import { useFormikContext } from "formik";
import React from "react";
import FormGroup from "shared/form/fields/formGroup";
import FormLabel from "shared/form/fields/formLabel";
import FormSelectDropdownField from "shared/form/fields/selectDropdown";
import { getFormattedCurrency } from "shared/utils";
import { useCopies } from "shared/hooks/useCopies";
import { BulkTicketQuantityProps } from "./type";
import { FormFieldOption } from "shared/form/fields/types";
import { useDynamicFormRenderer } from "shared/form/renderer/context/dynamicFormRendererContext";
import { Menu, MenuButton, MenuPopover } from "@reach/menu-button";
import BulkQuantityPriceBreakUpMap from "../../../../shared/components/bulkQuantityPriceBreakUpMap";

export default function BulkTicketQuantity(props: BulkTicketQuantityProps) {
  const copies = useCopies();
  const { values } = useFormikContext<any>();
  const { applicableRates } = useDynamicFormRenderer();
  const selectedOption = props.options.find((o: FormFieldOption) => {
    return o.value === values[props.name];
  });

  const totalAmount = React.useMemo(() => {
    if (selectedOption) {
      return getFormattedCurrency({
        value: parseFloat(selectedOption.value) * parseFloat(selectedOption.customData.value),
        currencyCode: selectedOption.customData.currencyCode
      });
    }
    return 0;
  }, [selectedOption]);

  return (
    <React.Fragment>
      <FormGroup>
        <FormLabel
          className="bulkTicketQuantityLabel"
          label={
            <React.Fragment>
              {props.label}
              {applicableRates && applicableRates?.length > 0 && (
                <div className="dropDnMenu dropDnMenu--tooltip">
                  <Menu>
                    <MenuButton>{copies.get("view.pricing")}</MenuButton>
                    <MenuPopover className="slide-down newMenuDropdownList newMenuDropdownList--tooltip">
                      <div className="newMenuDropdownList--container">
                        <div className="newMenuDropdownList--items">
                          {
                            <BulkQuantityPriceBreakUpMap
                              applicableRates={applicableRates}
                              perQuantityDisplayText={copies.get("price.per.ticket")}
                              labelDisplayText={copies.get("pricing.cards.title")}
                            />
                          }
                        </div>
                      </div>
                    </MenuPopover>
                  </Menu>
                </div>
              )}
            </React.Fragment>
          }
        />
        <FormSelectDropdownField
          label={""}
          options={props.options}
          name={props.name}
          required={props.required}
          disabled={props.disabled}
          fullWidth
          className={"bulkTicketQuantity"}
        />
      </FormGroup>
      {selectedOption && (
        <div className="bulkTicketTotalAmount--mobileShow">
          <label className="bulkTicketTotalAmount--label">{copies.get("total.amount")}:</label>
          <p className="bulkTicketTotalAmount--value">{totalAmount}</p>
        </div>
      )}
      {selectedOption && (
        <FormGroup className="bulkTicketTotalAmount--mobileHide">
          <FormLabel label={copies.get("total.amount")} />
          <p className="bulkTicketTotalAmount--value">{totalAmount}</p>
        </FormGroup>
      )}
    </React.Fragment>
  );
}
